import { UpsellType } from '../types';
import { TrackingIdType, UpsellDismissedStorageKey } from '../types';

const RENTAL_MANAGER_API_PREFIX = 'rental-manager-api';
const RENTER_HUB_API_PREFIX = 'renter-hub-api';
const RINS_API_URL = 'api/v2/users/rins';
const REQUEST_OPTIONS: RequestInit = {
  credentials: 'include',
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
};

const buildBaseUrlWithProxyPath = (proxyPath: string = '') => {
  const baseUrl = `${RENTER_HUB_API_PREFIX}/${RINS_API_URL}`;

  if (proxyPath) {
    if (proxyPath.startsWith('/')) {
      proxyPath = proxyPath.substring(1);
    }
    if (proxyPath.endsWith('/')) {
      proxyPath = proxyPath.substring(0, proxyPath.length - 1);
    }

    return `${window.location.origin}/${proxyPath}/${baseUrl}`;
  }

  return `${window.location.origin}/${baseUrl}`;
};

const buildLeaseBaseUrl = (apiUrl: string) => {
  if (apiUrl.endsWith('/')) {
    apiUrl = apiUrl.substring(0, apiUrl.length - 1);
  }

  return `${apiUrl}/${RENTAL_MANAGER_API_PREFIX}/${RINS_API_URL}`;
};

const getUpsellDismissedLocalStorageKey = (upsellType: UpsellType) => {
  if (upsellType === UpsellType.LEASES_PAGE) {
    return UpsellDismissedStorageKey.LEASES;
  } else if (upsellType === UpsellType.YOUR_RENTAL_PAGE) {
    return UpsellDismissedStorageKey.YOUR_RENTAL;
  }

  return UpsellDismissedStorageKey.YOUR_RENTAL_APPLICATIONS;
};

const hasUpsellBeenDismissed = (upsellType: UpsellType, trackingIdType: TrackingIdType, trackingId: string) => {
  const localStorageKey = getUpsellDismissedLocalStorageKey(upsellType);
  const localStorageValue = localStorage.getItem(`${localStorageKey}${trackingId}`);

  if (localStorageValue !== null) {
    const parsedLocalStorageValue = JSON.parse(localStorageValue);
    return trackingIdType == TrackingIdType.LEASE_ID ? !parsedLocalStorageValue : parsedLocalStorageValue;
  }

  return false;
};

export const clickMockUpsell = async () => {};

export async function clickUpsell(
  upsellId: string,
  trackingIdType: TrackingIdType,
  apiUrl: string,
  proxyPath: string = '',
) {
  const baseUrl =
    trackingIdType == TrackingIdType.LEASE_ID ? buildLeaseBaseUrl(apiUrl) : buildBaseUrlWithProxyPath(proxyPath);
  const url = `${baseUrl}/clickUpsell`;
  const requestOptions = { ...REQUEST_OPTIONS, body: JSON.stringify({ upsellId }) };
  const res = await fetch(url, requestOptions);
  const response = await res.json();
  return response;
}

export const createMockUpsell = async () => ({
  id: 'upsellId',
  monthlyPriceEstimate: '$10',
  shouldDisplayUpsell: true,
  url: 'https://www.zillow.com',
  zip: '12345',
});

export async function createUpsell(
  upsellType: UpsellType,
  trackingIdType: TrackingIdType,
  trackingId: string,
  apiUrl: string = '',
  proxyPath: string = '',
) {
  if (hasUpsellBeenDismissed(upsellType, trackingIdType, trackingId)) {
    return { shouldDisplayUpsell: false };
  }

  const baseUrl =
    trackingIdType == TrackingIdType.LEASE_ID ? buildLeaseBaseUrl(apiUrl) : buildBaseUrlWithProxyPath(proxyPath);
  const url = `${baseUrl}/createUpsell`;
  const requestOptions = {
    ...REQUEST_OPTIONS,
    body: JSON.stringify({
      type: upsellType,
      trackingIdType,
      trackingId,
    }),
  };

  try {
    const res = await fetch(url, requestOptions);
    const response = await res.json();

    if (response.success) {
      return response.response;
    }

    return { isFailure: true, shouldDisplayUpsell: false };
  } catch (error) {
    return { isFailure: true, shouldDisplayUpsell: false };
  }
}

export async function optOutFromUpsell(upsellId: string, reason: string, shouldHide: boolean, apiUrl: string) {
  const url = `${buildLeaseBaseUrl(apiUrl)}/optOutFromUpsell`;
  const requestOptions = {
    ...REQUEST_OPTIONS,
    body: JSON.stringify({
      upsellId,
      reason,
      shouldHide,
    }),
  };
  const res = await fetch(url, requestOptions);
  const response = await res.json();
  return response;
}

export const viewMockUpsell = async () => {};

export async function viewUpsell(
  upsellId: string,
  trackingIdType: TrackingIdType,
  apiUrl: string,
  proxyPath: string = '',
) {
  const baseUrl =
    trackingIdType == TrackingIdType.LEASE_ID ? buildLeaseBaseUrl(apiUrl) : buildBaseUrlWithProxyPath(proxyPath);
  const url = `${baseUrl}/viewUpsell`;
  const requestOptions = { ...REQUEST_OPTIONS, body: JSON.stringify({ upsellId }) };

  try {
    const res = await fetch(url, requestOptions);
    const response = await res.json();
    return response;
  } catch (error) {
    return;
  }
}
